import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose} from 'recompose';
import {
  saveAnnotationRequest,
  selectAnnotationSave
} from '../redux/reducers/annotations';

import {
  getUserProgramsFullRequest,
} from '../redux/reducers/userProgramsFull';
import Clear from '@material-ui/icons/Clear';
import Popup from './Popup';
import { STORAGE_LINK } from '../constants';



class PDFTron extends Component {
  constructor() {
    super();
    this.viewer = React.createRef();
    this.docViewer = null;
    this.annotManager = null;
    this.instance = null;
  }

  componentDidMount() {
    window.WebViewer({
      path: '/lib',
      initialDoc: this.props.selectedContentItem.path,
      forceClientSideInit: true,
      mobileRedirect: false,
      preloadWorker: 'all',
      fullAPI: true,
      licenseKey: 'Cornerstone Performance Solutions(performancesolutions.co.za):OEM:Cornerstone Learning Management System (LMS)::B+:AMS(20200728):C9A5D42D0437880A3360B13AC9A2737860610F9BAF76BD53AB440D3344026ECE64FAB6F5C7'
    }, this.viewer.current).then(instance => {
      // at this point, the viewer is 'ready'
      // call methods from instance, docViewer and annotManager as needed
      this.instance = instance;
      this.docViewer = instance.docViewer;
      this.annotManager = instance.annotManager;
     

      // you can also access major namespaces from the instance as follows:
      // var Tools = instance.Tools;
      // var Annotations = instance.Annotations;

      // now you can access APIs through `this.instance`
      this.instance.openElement('notesPanel')

      // or listen to events from the viewer element
      this.viewer.current.addEventListener('pageChanged', (e) => {
        const [ pageNumber ] = e.detail;
        console.log(`Current page is ${pageNumber}`);
      });

      // or from the docViewer instance
      this.docViewer.on('annotationsLoaded', () => {
        console.log('annotations loaded');
      });

      this.docViewer.on('documentLoaded', this.wvDocumentLoadedHandler)
    })
  }
  


  wvDocumentLoadedHandler = () => {

    // see https://www.pdftron.com/api/web/WebViewer.html for the full list of low-level APIs
    
    fetch(STORAGE_LINK+this.props.selectedContentItem.pdf_json, {
      method: 'GET'
    }).then(response => {
     
      if (response.status === 200) {
        response.text().then(xfdfString => {
          this.annotManager.importAnnotations(xfdfString);
        });
      }
    });
  }

  saveAnnotations = () => {
    this.props.selectAnnotationSave(this.annotManager.exportAnnotations({ links: false, widgets: false }))
    this.props.saveAnnotationRequest()
    this.props.handlePopupToggleDocument(this.props.selectedContentItem)
  }

  

  render() {
    return (
      <Popup>
    
    <div style={{
      backgroundColor: 'rgba(50,50,50,0.85)',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      zIndex: 2000
    }}>
      <div style={{top: 0,
        left: 0,
        border: 0,
        width: '100%',
        height: '100%',
      }}>
      <div style={{display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: 64,
      }}>
          <Clear
            style={{
              color: '#fff',
              background: 'transparent',
              alignSelf: 'flex-end',
              cursor: 'pointer',
              margin: '20px 15px 0 0',}}
            onClick={() => {
              this.saveAnnotations()
            }}
          />
        </div>
        <div style={{ 
                      position: 'relative',
                      overflow: 'scroll',
                      height: 'calc(100% - 64px)',
        }}>
      <div style={{width: '100%',height: "100%", display: 'flex',
        flexDirection: "column"}}>
       
        <div className="webviewer" ref={this.viewer} style={{height:'100%'}}></div>
      </div>
      </div>
      </div>
      </div>
     
      </Popup>
    );
  }
}


const mapStateToProps = state => ({
  view: state.viewReducer,
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
  annotationsReducer: state.annotationsReducer
});

const mapDispatchToProps = dispatch => ({
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  selectAnnotationSave: json => dispatch(selectAnnotationSave(json)),
  saveAnnotationRequest: () => dispatch(saveAnnotationRequest()),
});


export default compose(connect(mapStateToProps,mapDispatchToProps))(PDFTron);



// WEBPACK FOOTER //
// ./src/Components/PDFTron.jsx